import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";

import { AccountType } from "@/modules/Accounts/types";

interface AccountTypeChoiceGroupProps {
  accountType?: AccountType;
  disabled?: boolean;
  showOnlySelected?: boolean;
  onChange: (accountType: AccountType) => void;
}

interface AccountTypeChoiceParams {
  accountType: AccountType;
  text: string;
  iconName: string;
  color: string;
  background: string;
  marginLeft?: string | number;
  innerMarginLeft: string;
}

const cardShadow =
  "rgba(0, 0, 0, 0.05) 0px 10px 20px, rgba(0, 0, 0, 0.05) 0px 6px 6px";

function isAccountType(value: unknown): value is AccountType {
  return value === AccountType.PHYSICAL || value === AccountType.LEGAL;
}

const createAccountTypeChoice = ({
  accountType,
  text,
  iconName,
  color,
  background,
  marginLeft = 0,
  innerMarginLeft
}: AccountTypeChoiceParams): IChoiceGroupOption => ({
  key: accountType,
  text,
  iconProps: { iconName },
  styles: {
    root: {
      display: "flex",
      flexDirection: "row !important",
      justifyContent: "center",
      background,
      borderRadius: "5px",
      width: "35%",
      height: "50px",
      marginLeft,
      boxShadow: cardShadow
    },
    labelWrapper: {
      color,
      fontWeight: "500",
      fontSize: "18px",
      minWidth: "70%",
      height: "fit-content",
      display: "flex"
    },
    field: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      color,
      borderRadius: "5px",
      paddingTop: "0px"
    },
    iconWrapper: {
      color,
      fontSize: "25px"
    },
    innerField: {
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: innerMarginLeft
    },
    choiceFieldWrapper: {
      borderRadius: "5px",
      width: "100%",
      height: "100%"
    }
  }
});

const accountTypeChoices = [
  createAccountTypeChoice({
    accountType: AccountType.PHYSICAL,
    text: "Pessoa Física",
    iconName: "Contact",
    color: "#00427c",
    background: "#00427a13",
    innerMarginLeft: "50px"
  }),
  createAccountTypeChoice({
    accountType: AccountType.LEGAL,
    text: "Pessoa Jurídica",
    iconName: "CityNext",
    color: "#107c10",
    background: "#28ee0013",
    marginLeft: "10px",
    innerMarginLeft: "35px"
  })
];

export function AccountTypeChoiceGroup({
  accountType,
  disabled,
  showOnlySelected,
  onChange
}: AccountTypeChoiceGroupProps): JSX.Element {
  const options =
    showOnlySelected && accountType
      ? accountTypeChoices.filter(
          choice => String(choice.key) === String(accountType)
        )
      : accountTypeChoices;

  return (
    <ChoiceGroup
      options={options}
      onChange={(_, item) => {
        if (isAccountType(item?.key)) {
          onChange(item.key);
        }
      }}
      radioGroup="none"
      styles={{
        root: {
          overflow: "hidden",
          width: "100%"
        },
        flexContainer: {
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "15px"
        }
      }}
      disabled={disabled}
      selectedKey={accountType ?? ""}
    />
  );
}
